var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVLo5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 84,
    viewBox: "0 0 82 84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prima-Versione",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0 0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANTICIPO-TFS---DOCUMENTI",
    transform: "translate(-752 -1683)",
    stroke: "#FCBB00",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "v_lo_5",
    transform: "translate(755 1686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.213 14.426L76.066 14.426M0 14.426L28.852 14.426M47.213 52.459L76.066 52.459M47.213 76.066L76.066 76.066M61.639 28.852L61.639 0M0 78.689L28.852 49.836M28.852 78.689L0 49.836"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLo5);
export default __webpack_public_path__ + "static/media/v_lo_5.f27e6e84a49ae71bc43706f482197f6d.svg";
export { ForwardRef as ReactComponent };